/* eslint-disable no-restricted-syntax */

import { sumBy } from 'lodash';
import { mapActions } from 'vuex';
import switchModal from '@/components/generics/modal/switch/switch.vue';
import { capitalizeFirstLetter } from '@/utils/helpers';

export default {
  components: {
    switchModal,
  },
  props: {
    items: {},
    price: {
      type: Number,
      required: true,
    },
    operationType: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    title() {
      return `${capitalizeFirstLetter(this.operationType)} Offers at ${this.price}¢`;
    },
    hasBeforeMeOffers() {
      return this.groupedRecords.length > 1 &&
        !this.groupedRecords[0][0].isMine;
    },
    hasAfterMeOffers() {
      return this.groupedRecords.length > 1 &&
        !this.groupedRecords[this.groupedRecords.length - 1][0].isMine;
    },
    groupedRecords() {
      if (this.items.length === 0) return [];

      const results = [];
      let temp = [];
      let previousFlag = null;

      for (const item of this.items) {
        if (previousFlag !== null && (item.isMine !== previousFlag)) {
          results.push([...temp]);
          temp = [];
        }

        temp.push(item);
        previousFlag = item.isMine;
      }
      results.push([...temp]);

      return results;
    },
  },
  methods: {
    isFirstGroupedIndex(index) {
      return index === 0;
    },
    isLastGroupedIndex(index) {
      return index === (this.groupedRecords.length - 1);
    },
    areMine(records) {
      return records[0].isMine;
    },
    rowClassModifiers(records) {
      return {
        'offers-indicator--highlight': this.areMine(records),
      };
    },
    ...mapActions('overlay', {
      hideOverlay: 'hide',
    }),
    displayRecords(records) {
      return sumBy(records, i => i.quantity);
    },
    close() {
      this.$emit('modalClose');
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/offers-indicator-popup/offers-indicator-popup.js